import React from "react";
import "./customerOptions.css";
import FindPlayCard from "../../../Asset/Play.svg";
import FindCommunityCard from "../../../Asset/Community.svg";
import FindCompetitionCard from "../../../Asset/Competition.svg";

import greenb1 from "../../../Asset/CustomerOptionsHomepage/green-box-1.svg";
import greenb2 from "../../../Asset/CustomerOptionsHomepage/green-box-2.svg";
import greenb3 from "../../../Asset/CustomerOptionsHomepage/green-box-3.svg";
import play from "../../../Asset/CustomerOptionsHomepage/play.svg";
import community from "../../../Asset/CustomerOptionsHomepage/community.svg";
import competition from "../../../Asset/CustomerOptionsHomepage/competition.svg";

const customerOptions = () => {
  return (
    <div className="w-full bg-[rgba(242,242,242,1)] flex flex-col pb-10 mdpb-0 md:p-10 text-[var(--greenish-black)] ">
      {/* Upper Container */}
      <div className="customerOptions-upper-container flex flex-col md:flex-row justify-between px-4 md:px-0 mb-5 md:mb-10">
        <div className="two-columns md:w-1/2 w-[96%] text-left  text-[2.5rem] md:text-5xl lg:text-[3.5rem]  font-[490]">
          <h1 className="font-ClashGrotesk mb-8 md:mb-0  md:ml-0 text-[var(--gray-black)] ">
            What's in it <br className="hidden md:block" />
            for you
          </h1>
        </div>
        <div className="two-columns md:w-1/2  font-manrope text-base md:text-xl md:pl-4 font-[490] text-left">
          <p>
            Imagine a weekend soirée, where you earn your cold ones by sweating
            it out first. Prepare to rub shoulders with your future besties,
            unleash your competitive spirit, and forge bonds that could outlast
            the longest winning streak. Get ready to be part of the most
            sought-after sports social club ever assembled!{" "}
          </p>
        </div>
      </div>

      {/* Lower Container */}

      {/* For Mobile view only */}
      <div className="md:hidden carousel space-x-4 w-full flex mt-5 mb-16 md:mt-8 md:mb-16 md:px-0 font-[520] text-[var(--greenish-black)]">
        {/* Item 1 */}
        <div className="carousel-item w-[50vw] md:w-[60vw] pl-4">
          <div
            className="
        bg-no-repeat 
        bg-center 
        bg-contain 
        aspect-square 
        w-[50vw] 
        p-[4vw]
      "
            style={{ backgroundImage: `url(${play})` }}
          >
            <h1 className="font-ClashGrotesk mb-2 text-[5.4vw] sm:text-[4vw] md:text-xl text-[#293F03]">
              Find Play
            </h1>
            <p className="font-manrope text-[3.6vw] sm:text-[3vw] md:text-sm text-[#293F03]">
              Find your inner athlete and make play part of your every day.
            </p>
          </div>
        </div>

        {/* Item 2 */}
        <div className="carousel-item w-[50vw] md:w-[60vw]  ">
          <div
            className="
        bg-no-repeat 
        bg-center 
        bg-contain 
        aspect-square 
        w-[50vw] 
        p-[4vw]
      "
            style={{ backgroundImage: `url(${community})` }}
          >
            <h1 className="font-ClashGrotesk mb-2 text-[5.4vw] sm:text-[4vw] md:text-xl text-[#293F03]">
              Find Community
            </h1>
            <p className="font-manrope text-[3.6vw] sm:text-[3vw] md:text-sm text-[#293F03]">
              Play your way to a healthier you. Join our community and discover
              the joy of fitness.
            </p>
          </div>
        </div>

        {/* Item 3 */}
        <div className="carousel-item w-[50vw] md:w-[60vw] pr-4  ">
          <div
            className="
        bg-no-repeat 
        bg-center 
        bg-contain 
        aspect-square 
        w-[50vw] 
        p-[4vw]
      "
            style={{ backgroundImage: `url(${competition})` }}
          >
            <h1 className="font-ClashGrotesk mb-2 text-[5.4vw] sm:text-[4vw] md:text-xl text-[#293F03]">
              Find Competition
            </h1>
            <p className="font-manrope text-[3.6vw] sm:text-[3vw] md:text-sm text-[#293F03]">
              A dash of playful rivalry keeps the fun alive—engage, compete, and
              watch the excitement grow.
            </p>
          </div>
        </div>
      </div>

      {/* for desktop and medium view only */}
      <div className="customerOptions-bottom-container w-full md:flex md:flex-nowrap items-center justify-between  mb-16 hidden ">
        <div className="customerOptions-card find-play w-[32%]">
          <img className="w-full " src={FindPlayCard} alt="Find Play Card" />
        </div>
        <div className="customerOptions-card find-community w-[32%]">
          <img
            className="w-full"
            src={FindCommunityCard}
            alt="Find Community Card"
          />
        </div>
        <div className="customerOptions-card find-competition w-[32%]">
          <img
            className="w-full"
            src={FindCompetitionCard}
            alt="Find Competition Card"
          />
        </div>
      </div>
    </div>
  );
};

export default customerOptions;
